import { type ChangeEvent, memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { COLORS } from "../../constants/colors";
import type { ColorItem } from "../../types";
import styles from "./ColorMenu.module.css";
import { ColorMenuButton } from "./ColorMenuButton";

interface ColorMenuContentProps {
    colorValue: string;
    onColorClick: (item: ColorItem) => void;
    onColorInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const ColorMenuContent = memo(function ColorMenuContent({
    colorValue,
    onColorClick,
    onColorInputChange,
}: ColorMenuContentProps) {
    return (
        <HStack gap={2} wrap="wrap" className={styles.colors}>
            {COLORS.map((item) => {
                return (
                    <ColorMenuButton
                        key={item.color}
                        item={item}
                        colorValue={colorValue}
                        onColorClick={onColorClick}
                        onColorInputChange={onColorInputChange}
                    />
                );
            })}
        </HStack>
    );
});
